import { ModalRef, PreworkSectionData } from 'constants/WorkingModePathwaysConstants'

import { renderSegments } from './renderSegments'
import { WorkflowStepCard } from './WorkflowStepCard'
import { WorkstreamCard } from './WorkstreamCard'

interface PreworkSectionProps {
  data: PreworkSectionData
  onOpenModal: (ref: ModalRef) => void
}

export const PreworkSection = ({ data, onOpenModal }: PreworkSectionProps) => (
  <div className="flex flex-col gap-6 items-center justify-center w-full">
    <p className="subtitle-xl w-full">
      {data.title} ({data.durationLabel})
    </p>
    <div className="flex gap-6 items-start w-full">
      {data.textColumns.map(column => (
        <div key={column.title} className="flex flex-col gap-2 items-start flex-1 min-w-0">
          <p className="title-xxs w-full">{column.title}</p>
          {column.segments && <p className="body-s w-full">{renderSegments(column.segments)}</p>}
          {column.bullets && (
            <ul className="pathway-bullets">
              {column.bullets.map(bullet => (
                <li key={bullet} className="body-s">
                  {bullet}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
    <div className="pathway-divider" />
    {data.workstreamCards && (
      <div className="flex gap-4 items-stretch w-full">
        {data.workstreamCards.map(card => (
          <div key={card.key} className="flex-1 min-w-0">
            <WorkstreamCard card={card} onOpenModal={onOpenModal} />
          </div>
        ))}
      </div>
    )}
    {data.workflow && (
      <div className="flex flex-col gap-4 items-center w-full">
        <p className="title-xxs w-full">{data.workflow.title}</p>
        <div className="pathway-workflow-steps-grid">
          {data.workflow.steps.map(step => (
            <div key={step.number} className="pathway-workflow-step-wrapper">
              <WorkflowStepCard step={step} />
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
)
